import { jsxs as n, jsx as o } from "react/jsx-runtime";
import "react";
import { Concat as V } from "../Concat/Concat.js";
import { CtaBlock as Q } from "../CtaBlock/CtaBlock.js";
import { StringList as X } from "../StringList/StringList.js";
import { p as R } from "../../index-B0ARwqly.mjs";
import { classes as d } from "../../utils/helpers.js";
import { s as Y } from "../../sub-CkNH5u-l.mjs";
import { f as _ } from "../../format-plq8pBNY.mjs";
import '../../assets/ProgramAirdate.css';const i = {
  "program-airdate": "_program-airdate_et1s5_1",
  "program-airdate__descriptor": "_program-airdate__descriptor_et1s5_5",
  "program-airdate__logo": "_program-airdate__logo_et1s5_11",
  "program-airdate--missing-logo": "_program-airdate--missing-logo_et1s5_30"
};
function re({
  brand: p = "",
  program: e,
  type: u = "on-now",
  buttonStyle: c = "flat",
  // flat or gradient
  logoStyle: s = "gradient",
  // gradient or anything else that's not gradient
  useLogo: l = !0,
  useSeriesColors: a = !0,
  href: b = ""
}) {
  var v, y, $, k, C, N, g, w, E, H, F, G, M, x, B, I, P, T, j, A, D, W, q, z, J, K, O;
  const m = /* @__PURE__ */ new Map([
    ["on-now", "Now Playing on "],
    ["on-tomorrow", "Playing Tomorrow on "],
    ["upcoming", "Coming Soon on "]
  ]), r = e != null && e.airdate ? new Date(e.airdate.replace(" ", "T")) : null, U = e != null && e.airdate ? Y(r, { hours: 1 }) : null, f = e != null && e.airdate ? r.getMinutes() === 0 ? "" : _(r, ":mm") : null, h = e != null && e.airdate ? `${_(r, "h")}${f}${Number.parseInt(_(r, "H"), 10) < 12 ? "a" : ""}/${_(U, "h")}${f}c` : "";
  if ((e == null ? void 0 : e.program_class) === "Episode") {
    let t;
    return e.episode.season === null && e.episode.number === null ? t = null : e.episode.season === null || e.episode.number === null ? e.episode.season === null ? t = `E${e.episode.number}` : t = `S${e.episode.season}` : t = `S${e.episode.season} E${e.episode.number}`, /* @__PURE__ */ n(
      "div",
      {
        className: d([i["program-airdate"], "program-airdate"]),
        style: {
          "--pa-logo-image": s === "gradient" && l ? `url("${($ = (y = (v = e.episode.series) == null ? void 0 : v.logo) == null ? void 0 : y.black) == null ? void 0 : $.url}")` : null,
          "--pa-gradient": s === "gradient" && l ? `linear-gradient(to bottom, ${e.episode.series.primary_color} 0%, ${e.episode.series.secondary_color} 100%)` : null,
          "--pa-logo-aspect-ratio": l && e.episode.series.logo ? e.episode.series.logo.aspect_ratio : null,
          "--pa-color": e.episode.series.secondary_color
        },
        children: [
          /* @__PURE__ */ n("div", { className: i["program-airdate__descriptor"], children: [
            m.get(u),
            p
          ] }),
          /* @__PURE__ */ n(
            "div",
            {
              className: d([
                i["program-airdate__logo"],
                "program-airdate__logo",
                (N = (C = (k = e.episode.series) == null ? void 0 : k.logo) == null ? void 0 : C.black) != null && N.url ? "" : i["program-airdate--missing-logo"]
              ]),
              "data-style": s,
              style: {
                maskImage: (E = (w = (g = e.episode.series) == null ? void 0 : g.logo) == null ? void 0 : w.black) != null && E.url && s === "gradient" && l ? `url('${(G = (F = (H = e.episode.series) == null ? void 0 : H.logo) == null ? void 0 : F.black) == null ? void 0 : G.url}')` : null,
                WebkitMaskImage: (B = (x = (M = e.episode.series) == null ? void 0 : M.logo) == null ? void 0 : x.black) != null && B.url && s === "gradient" && l ? `url('${(T = (P = (I = e.episode.series) == null ? void 0 : I.logo) == null ? void 0 : P.black) == null ? void 0 : T.url}')` : null
              },
              children: [
                (D = (A = (j = e.episode.series) == null ? void 0 : j.logo) == null ? void 0 : A.black) != null && D.url && l ? /* @__PURE__ */ o("span", { className: "sr-only", children: e.episode.series.name.replace(/<br\s*\/?>/i, " ") }) : /* @__PURE__ */ o("span", { children: R(e.episode.series.name) }),
                s !== "gradient" && ((z = (q = (W = e.episode.series) == null ? void 0 : W.logo) == null ? void 0 : q.black) == null ? void 0 : z.url) && l && /* @__PURE__ */ o(
                  "img",
                  {
                    className: d([i["program-airdate__logo-image"], "program-airdate__logo-image"]),
                    src: (O = (K = (J = e.episode.series) == null ? void 0 : J.logo) == null ? void 0 : K.black) == null ? void 0 : O.url,
                    alt: e.episode.series.name.replace(/<br\s*\/?>/i, " ")
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ o(
            Q,
            {
              content: /* @__PURE__ */ o(V, { list: [
                `<strong>${h}</strong><br/>`,
                /* @__PURE__ */ o(X, { list: [t, e.episode.name], separatorType: "pipe" })
              ] }),
              type: "internal-link",
              cta: {
                label: "Full Schedule",
                href: b
              },
              ctaButtonStyle: c,
              btnGradientStartColor: c === "gradient" ? a ? e.episode.series.secondary_color : "var(--theme-color-400)" : "",
              btnGradientEndColor: c === "gradient" ? a ? e.episode.series.primary_color : "var(--theme-color-300)" : "",
              btnFlatColors: {
                bgColor: a ? e.episode.series.primary_color : "var(--theme-color-400)",
                // when ready use color function for hover colors: hsl(from var(--theme-color-400) h s calc(l + 0.1))
                bgHoverColor: a ? e.episode.series.secondary_color : "var(--mono-color-300)",
                color: "#fff",
                hoverColor: "#fff",
                borderColor: a ? e.episode.series.primary_color : "var(--theme-color-400)",
                borderHoverColor: a ? e.episode.series.secondary_color : "var(--mono-color-300)"
              }
            }
          )
        ]
      }
    );
  } else
    return /* @__PURE__ */ n("div", { className: d([i["program-airdate"], "program-airdate"]), children: [
      /* @__PURE__ */ n("div", { className: i["program-airdate__descriptor"], children: [
        m.get(u),
        p
      ] }),
      /* @__PURE__ */ o(
        "div",
        {
          className: d([
            i["program-airdate__logo"],
            "program-airdate__logo",
            i["program-airdate--missing-logo"]
          ]),
          "data-style": s,
          children: /* @__PURE__ */ o("span", { children: R(e.name) })
        }
      ),
      /* @__PURE__ */ o(
        Q,
        {
          content: `<strong>${h}</strong>`,
          type: "internal-link",
          cta: {
            label: "Full Schedule",
            href: b
          },
          ctaButtonStyle: c,
          btnGradientStartColor: "",
          btnGradientEndColor: "",
          btnFlatColors: {
            bgColor: e.primary_color,
            bgHoverColor: e.secondary_color,
            color: "#fff",
            hoverColor: "#fff",
            borderColor: e.primary_color,
            borderHoverColor: e.secondary_color
          }
        }
      )
    ] });
}
export {
  re as ProgramAirdate,
  re as default
};
